const VideoListLoading = () => {
  return (
    <div className="animate-pulse w-40">
      <div className="flex-1 space-y-6 py-1">
        <div className="space-y-3">
          <div className="h-[120px] bg-gray-300 rounded col-span-2"></div>
          <div className="grid grid-cols-3 gap-4">
            <div className="h-3 bg-gray-300 rounded col-span-2"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VideoListLoading
